import signedFetch from '../util/signedFetch.js';

export default (orgId, toolId = '', data) =>
  signedFetch('lmsConfig', `${__API_BASE__}/org/${orgId}/lms-config/tools/${toolId}`, toolId ? 'PUT' : 'POST', data);
